<template>
  <div class="column agent-info tw-font-inter tw-mt-2 tw-mb-1 tw-rounded-xl tw-border tw-border-solid tw-border-line tw-bg-white tw-shadow-[0_10px_24px_-14px_rgba(23,105,182,0.45)]">
    <div class="col q-mb-sm">
      <div class="row items-center no-wrap q-px-xs q-pt-sm">
        <div class="col-auto tw-mr-2 tw-flex tw-h-8 tw-w-8 tw-select-none tw-items-center tw-justify-center tw-rounded-full tw-bg-primary/10 tw-text-[13px] tw-font-semibold tw-text-primary">
          {{ (agentName || '?').charAt(0).toUpperCase() }}
        </div>

        <div class="col tw-min-w-0">
          <div class="column">
            <div
              class="col"
              :key="`spinner${loading}`"
            >
              <q-spinner-dots
                v-if="loading"
                size="xs"
                color="blue-grey-10"
                class="q-ml-md"
                indeterminate
              />
              <span
                v-else
                class="tw-block ellipsis agent-name tw-text-[13px] tw-font-semibold tw-leading-4 tw-text-bluegrey-10"
              >
                {{ agentName }}
                <q-tooltip>{{ agentName }}</q-tooltip>
              </span>
            </div>

            <div class="col tw-mt-0.5">
              <span
                class="tw-inline-flex tw-w-fit tw-items-center tw-gap-1.5 tw-rounded-full tw-px-2 tw-py-[2px] tw-text-[11px] tw-font-medium"
                :class="statusChip.chip"
              >
                <span
                  class="tw-h-1.5 tw-w-1.5 tw-rounded-full"
                  :class="statusChip.dot"
                />
                {{ agentStatus }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col row items-center justify-start no-wrap tw-gap-1 tw-px-1.5 tw-pb-1">
      <div
        data-testid="agente-preview"
        v-if="!isAdmin"
        class="cursor-pointer tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-transition hover:tw-bg-greyc-4"
        @click="handlePreview"
      >
        <q-icon
          name="mdi-face-agent"
          size="18px"
          color="blue-grey-9"
        >
          <q-tooltip>Preview</q-tooltip>
        </q-icon>
      </div>

      <AgentQueuesButton />

      <div
        data-testid="agente-agenda"
        class="cursor-pointer tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-transition hover:tw-bg-greyc-4"
        @click="handleCalendar"
      >
        <q-icon
          name="mdi-calendar-account"
          size="18px"
          color="blue-grey-9"
        >
          <q-tooltip>Agenda</q-tooltip>
          <q-badge
            rounded
            v-if="todayNotifications.length"
            color="red"
            :label="todayNotifications.length"
            floating
          />
        </q-icon>
      </div>

      <div class="tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-transition hover:tw-bg-greyc-4">
        <router-link
          data-testid="agente-configuracoes"
          :to="{ name: ROUTE_SETTINGS }"
          class="tw-flex tw-items-center"
        >
          <SettingIcon class="settings-icon" />
        </router-link>
      </div>
    </div>

    <div
      class="col tw-mx-1.5 tw-mb-1.5 tw-rounded-xl tw-bg-greyc-1 tw-py-1.5"
      v-if="locationSummaryAgent !== 'rodape'"
    >
      <div class="tw-grid tw-grid-cols-3 tw-gap-x-1">
        <div class="tw-min-w-0">
          <div class="column items-center">
            <div class="col tw-max-w-full tw-truncate tw-text-xs tw-font-semibold tw-tabular-nums tw-text-bluegrey-10">
              <TimerSeconds
                :value="agent.summary.loginSecs"
              />
            </div>

            <div class="col">
              <span class="tw-block tw-max-w-full tw-truncate tw-text-[9px] tw-font-medium tw-uppercase tw-tracking-wide tw-text-gray-500">LOGADO</span>
            </div>
          </div>
        </div>

        <div class="tw-min-w-0">
          <div class="column items-center">
            <div class="col tw-max-w-full tw-truncate tw-text-xs tw-font-semibold tw-tabular-nums tw-text-bluegrey-10">
              <TimerSeconds
                v-if="agent.inAttendance"
                :value="agent.summary.callSecs"
              />
              <TimerLabel
                v-else
                :seconds="agent.summary.callSecs"
              />
            </div>

            <div class="col">
              <span class="tw-block tw-max-w-full tw-truncate tw-text-[9px] tw-font-medium tw-uppercase tw-tracking-wide tw-text-gray-500">ATENDIMENTO</span>
            </div>
          </div>
        </div>

        <div class="tw-min-w-0">
          <div class="column items-center">
            <div class="col tw-max-w-full tw-truncate tw-text-xs tw-font-semibold tw-tabular-nums tw-text-bluegrey-10">
              <TimerSeconds
                v-if="agent.paused"
                :value="agent.summary.pauseSecs"
              />

              <TimerLabel
                v-else
                :seconds="agent.summary.pauseSecs"
              />
            </div>
            <div class="col">
              <span class="tw-block tw-max-w-full tw-truncate tw-text-[9px] tw-font-medium tw-uppercase tw-tracking-wide tw-text-gray-500">PAUSA</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="col tw-mx-1.5 tw-mb-1.5 tw-rounded-xl tw-bg-greyc-1 tw-py-1.5"
      v-if="locationSummaryAgent !== 'rodape'"
    >
      <div class="tw-grid tw-grid-cols-3 tw-gap-x-1">
        <div class="tw-min-w-0">
          <div class="column items-center">
            <div class="col tw-max-w-full tw-truncate tw-text-xs tw-font-semibold tw-tabular-nums tw-text-bluegrey-10">
              <span>{{ totalAttendances || '-' }}</span>
            </div>

            <div class="col">
              <span class="tw-block tw-max-w-full tw-truncate tw-text-[9px] tw-font-medium tw-uppercase tw-tracking-wide tw-text-gray-500">
                {{ totalAttendances === 1 ? 'ATENDIMENTO' : 'ATENDIMENTOS' }}</span>
            </div>
          </div>
        </div>

        <div class="tw-min-w-0">
          <div class="column items-center">
            <div class="col tw-max-w-full tw-truncate tw-text-xs tw-font-semibold tw-tabular-nums tw-text-bluegrey-10">
              <TimerLabel :seconds="averageReceptiveOperation" />
            </div>
            <div class="col">
              <span class="tw-block tw-max-w-full tw-truncate tw-text-[9px] tw-font-medium tw-uppercase tw-tracking-wide tw-text-gray-500">TMO R</span>
            </div>
          </div>
        </div>

        <div class="tw-min-w-0">
          <div class="column items-center">
            <div class="col tw-max-w-full tw-truncate tw-text-xs tw-font-semibold tw-tabular-nums tw-text-bluegrey-10">
              <TimerLabel :seconds="averageActiveOperation" />
            </div>
            <div class="col">
              <span class="tw-block tw-max-w-full tw-truncate tw-text-[9px] tw-font-medium tw-uppercase tw-tracking-wide tw-text-gray-500">TMO A</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ROUTE_SETTINGS, ROUTE_CALENDAR, ROUTE_PREVIEW, ROUTE_PREVIEW_DETAILS, ROUTE_PREVIEW_CURRENT } from '@/router/constants'
import { DIRECTION_OUT } from '@/constants/directions'
import TimerLabel from '@/components/TimerLabel'
import TimerSeconds from '@/components/TimerSeconds'
import SettingIcon from '@/assets/icons/settings.svg'
import AgentQueuesButton from '@/components/AgentQueuesButton.vue'

export default {
  components: {
    TimerLabel,
    TimerSeconds,
    SettingIcon,
    AgentQueuesButton
  },

  data () {
    return {
      colorStatus: 'online',
      pauseReasonDescription: '',
      agentStatuses: {
        ONLINE: 'Online',
        OFFLINE: 'Offline',
        PAUSED: 'Pausa',
        CONNECTED: 'Em atendimento'
      },
      ROUTE_SETTINGS
    }
  },
  computed: {
    ...mapState({
      current: (state) => state.attendanceModule.current,
      attendanceHistory: (state) => state.attendanceModule.history,
      agent: (state) => state.agentModule.session.agent,
      loading: (state) => state.agentModule.session.loading,
      locationSummaryAgent: (state) => state.settingsModule.locationSummaryAgent,
      pauseReasons: (state) => state.agentModule.session.pauseReasons,
      agentGeral: (state) => state.agentModule,
      agentStatus ({ agentModule }) {
        const { session } = agentModule
        this.colorStatus = 'online'

        if (this.agent.pauseReasonId && (session?.agent?.status !== 'ONLINE')) {
          const pauseReasons = this.pauseReasons.reduce((acc, pauseReason) => {
            acc[pauseReason.id] = pauseReason
            return acc
          }, {})

          const pauseReasonId = this.agent?.pauseReasonId ?? ''
          const description = [null, undefined, '', false].includes(pauseReasonId) ? '' : pauseReasons[pauseReasonId]?.description ?? ''
          const objDescription = Object.assign(this.agentStatuses, { description: description })
          this.agentStatuses = objDescription
          this.colorStatus = 'offline'

          return this.agentStatuses.description
        }

        if (Object.keys(this.current).length >= 1) {
          const arrayValues = Object.values(this.current)
          const status = arrayValues.some((a) => ['HOLD', 'CONNECTED'].includes(a.status)) ? 'CONNECTED' : 'ONLINE'

          this.colorStatus = status === 'CONNECTED' ? 'ongoing' : 'online'

          return this.agentStatuses[status]
        }

        return this.agentStatuses[session?.agent?.status]
      },

      agentName ({ agentModule }) {
        const agent = agentModule?.session?.agent
        if (!agent) return ''

        return agent?.fullname ?? agent?.name ?? ''
      },

      isAgentBusy ({ agentModule }) {
        const { session } = agentModule
        const agentStatus = String(session?.agent?.status || '').trim().toUpperCase()
        const isRinging = agentStatus.includes('DIALING')
        const isOnline = agentStatus.includes('ONLINE')
        return !isOnline || isRinging
      }
    }),

    ...mapGetters({
      todayNotifications: 'calendarModule/todayNotifications',
      isAdmin: 'settingsModule/isAdmin',
      previewQueue: 'attendanceModule/previewQueue'
    }),

    totalAttendances () {
      return Object.keys(this.attendanceHistory).length
    },

    statusChip () {
      const map = {
        online: { chip: 'tw-bg-positive/10 tw-text-[#16A34A]', dot: 'tw-bg-positive' },
        offline: { chip: 'tw-bg-paused/15 tw-text-paused', dot: 'tw-bg-paused' },
        ongoing: { chip: 'tw-bg-primary/10 tw-text-primary', dot: 'tw-bg-primary' }
      }
      return map[this.colorStatus] || map.online
    },

    averageActiveOperation () {
      return this.calculateAverageOperation((a) => a.direction === DIRECTION_OUT && a.hangupAt)
    },

    averageReceptiveOperation () {
      return this.calculateAverageOperation((a) => a.direction !== DIRECTION_OUT && a.hangupAt)
    }
  },

  methods: {
    calculateAverageOperation (filter) {
      const values = Object.values(this.attendanceHistory)
        .filter(filter)
      const total = values.reduce((a, b) => {
        return a + (b.hangupAt - b.createdAt)
      }, 0) / values.length

      return (total / 1000) || 0
    },
    handleCalendar () {
      this.$router.push({ name: ROUTE_CALENDAR }).catch(() => { })
      this.$root.$emit('focus-target-destination')
    },

    handlePreview () {
      const routeName = this.$route.name

      const routeToPreview = () => routeName !== ROUTE_PREVIEW && this.$router.push({ name: ROUTE_PREVIEW })
      const routeToDetail = () => routeName !== ROUTE_PREVIEW_DETAILS && this.$router.push({ name: ROUTE_PREVIEW_DETAILS, params: { queueId: this.previewQueue } })
      const routeToCurrent = (attendanceId) => routeName !== ROUTE_PREVIEW_CURRENT && this.$router.push({ name: ROUTE_PREVIEW_CURRENT, params: { queueId: this.previewQueue, attendanceId } })

      if (!this.previewQueue) {
        routeToPreview()
        this.$root.$emit('focus-target-destination')
        return
      }

      const previewIsDialing = this.$store.state.attendanceModule.preview.status === 'DIALING'
      const callInPreview = Array.from(this.$store.state.attendanceModule.preview.attendances)[0]

      if (previewIsDialing || callInPreview) {
        routeToCurrent(callInPreview)
        this.$root.$emit('focus-target-destination')
        return
      }

      routeToDetail()

      this.$root.$emit('focus-target-destination')
    }
  }
}
</script>

<style lang="sass" scoped>
.settings-icon
  width: 18px
  height: 18px

.settings-icon > path
  fill: #37474F

.agent-info
 font-size: 11px

.agent-name
  max-width: 160px

</style>
